module.exports = __webpack_public_path__ + "img/FR13807.ca658ad9.png";